import React, { useReducer } from 'react';
import { DataContext, initialState, reducer } from '../stores/covering-table-store';

const CoveringTableContextWrapper = ({ children }) => {
    const [store, dispatch] = useReducer(reducer, initialState);

    return <DataContext.Provider value={{ store, dispatch }}>{children}</DataContext.Provider>;
};

export default CoveringTableContextWrapper;